import { Clickable, Col, Icon, Row, Text } from 'components';
import { useInfiniteScroll } from 'core';
import { Api } from 'lib';
import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Header, UserPanel } from 'screens/Admin/components';
import RefreshButton from '../Insights/components/RefreshButton';
import { Filters, List } from './components';
import { EMPTY_FILTERS } from './components/Filters';

let timer;

// Unset filters are sent as undefined, so the backend applies no condition for them.
function filterParams(filters) {
  return {
    emailVerified: filters.email.opt,
    idProgress: filters.id.opt,
    country: filters.country.value === 'Any' ? undefined : filters.country.value,
    anySport: filters.sport.opt
  };
}

const Users = ({}) => {
  const [type, setType] = useState({ value: 'All' }),
    [text, setText] = useState(''),
    [filters, setFilters] = useState(EMPTY_FILTERS),
    [dataId, setDataId] = useState(null),
    [sortBy, setSortBy] = useState({ name: 1 }),
    [filtered, setFiltered] = useState(null),
    [loading, setLoading] = useState(true),
    [refreshing, setRefreshing] = useState(false),
    { isMobile } = useSelector((state) => state.appState),
    dispatch = useDispatch(),
    { athleteCount = 0, teamCount = 0, fanCount = 0 } = useSelector((state) => state?.admin) || {},
    users = useSelector((state) =>
      state.admin?.users?.filter((x) =>
        type.value === 'Pending approval' ? x.verified?.idProgress === 'pendingVerification' : true
      )
    ),
    fetching = useRef(false),
    skip = useRef(0),
    totalUsersCount = [athleteCount, teamCount, fanCount].reduce((x, y) => x + y, 0),
    scrollId = 'admin-users-list';

  useInfiniteScroll(scrollId, getUsers);

  useEffect(() => {
    clearTimeout(timer);

    timer = setTimeout(() => {
      getUsers(true);
    }, 300);
  }, [text, type, sortBy, filters]);

  useEffect(() => {
    skip.current = users?.length || 0;
  }, [users]);

  function handleSelect(userId) {
    setDataId(userId);
  }

  async function getUsers(isFilterChange) {
    if (isFilterChange) {
      dispatch({
        type: 'ADMIN_SET_USERS',
        payload: null
      });
    }

    if (fetching.current) return;
    fetching.current = true;
    setRefreshing(true);

    const res = await Api.post('/admin/getUsers', {
      pendingVerify: type.value === 'Pending approval',
      admin: type.value === 'Admins',
      type: type.opt,
      skip: isFilterChange ? 0 : skip.current,
      text,
      sortBy,
      ...filterParams(filters)
    });

    setRefreshing(false);

    if (!res) return (fetching.current = false);

    dispatch({
      type: 'ADMIN_ADD_USERS',
      payload: res
    });

    fetching.current = false;
    setLoading(false);
  }

  return (
    <Col noFlex wid="100%" ht="100vh" start>
      <Header>
        <Row center>
          <Text h3>Users</Text>

          <Clickable onClick={() => setDataId(true)}>
            <Icon marg="0 0 0 8px" type="add" dimensions={18} />
          </Clickable>

          {/* The list is fetched on load and on filter change, so a user who verifies their email
              afterwards shows as unverified until this reloads it. */}
          <Row noFlex marg="0 0 0 12px">
            <RefreshButton
              title="Refresh users"
              refreshing={refreshing}
              onClick={() => getUsers(true)}
            />
          </Row>

          {/*
            <Row marg='0 0 0 60px'>
              <Text h4 regular>Total athletes: </Text>

              <Text h4 med marg='0 0 0 5px'>{athleteCount}</Text>
            </Row>

            <Row marg='0 0 0 30px'>
              <Text h4 regular>Total teams: </Text>

              <Text h4 med marg='0 0 0 5px'>{teamCount}</Text>
            </Row>

            <Row marg='0 0 0 30px' end>
              <Text h4 regular>Total fans: </Text>

              <Text h4 med marg='0 0 0 5px'>{fanCount}</Text>
            </Row>
          </Row>

          <Row marg='0 0 0 30px' noFlex center>
            <Text h3 regular>Total users: </Text>

            <Text h3 med marg='0 0 0 5px'>{totalUsersCount}</Text>
          */}
        </Row>
      </Header>

      <Col start noFlex marg="54px 0 0" wid="100%" ht="100vh" id={scrollId} scrollY>
        <Filters
          text={text}
          setText={setText}
          type={type}
          setType={setType}
          filters={filters}
          setFilters={setFilters}
          className="filters"
        />

        <List
          onClick={(userId) => setDataId(userId)}
          dataId={dataId}
          data={users}
          onSort={setSortBy}
          sortBy={sortBy}
          getUsers={getUsers}
          loading={loading}
        />
      </Col>

      <UserPanel dataId={dataId} closeModal={() => setDataId(null)} />
    </Col>
  );
};

export default Users;
